import React from 'react'

function ContactIco() {
  return (
    <a href="https://api.whatsapp.com/send?phone=201027295412&text=%D8%A7%D8%B2%D8%A7%D9%89%20%D9%85%D9%85%D9%83%D9%86%20%D9%86%D8%A8%D8%AF%D8%A7%20%D8%AA%D8%B9%D9%84%D9%8A%D9%85%20%D8%A7%D9%84%D8%A8%D8%B1%D9%85%D8%AC%D8%A9%20%D9%84%D9%84%D8%A7%D9%88%D9%84%D8%A7%D8%AF%20%D8%9F" className="whatsapp-widget w-inline-block"><img src="https://cdn.prod.website-files.com/655a78032f46f2e55da300d7/664b9a4de6e10b14bc62f52f_whatsapp.svg" loading="eager" alt="whatsapp button" />
        <div className="live-icon" />
    </a>
  )
}

export default ContactIco